var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGibraltar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0105C22.8794 32.0105 28.7441 27.6685 31.0047 21.5757H0.995117C3.25587 27.6685 9.12049 32.0105 16 32.0105Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2609 13.228V11.141H22.9565V9.74972H21.5652V10.4454H20.1739V9.74972H18.7826V11.141H19.4782V13.228H18.0869V8.35854H18.7826V6.96729H17.3913V7.66279H16.6956V6.96729H15.3044V7.66279H14.6087V6.96729H13.2174V8.35854H13.9131V13.228H12.5217V11.141H13.2174V9.74972H11.8261V10.4454H10.4348V9.74972H9.0435V11.141H9.73912V13.228H8.34781V18.7932H23.6522V13.228H22.2609Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 18.0977C14.8478 18.0977 13.9134 19.032 13.9134 20.1846C13.9134 21.0931 14.4943 21.8658 15.3047 22.1523V25.0542H13.2178V27.8368H16.696V22.1524C17.5065 21.8659 18.0873 21.0932 18.0873 20.1847C18.0873 19.0321 17.1529 18.0977 16.0003 18.0977ZM16.0003 20.8803C15.6161 20.8803 15.3047 20.5688 15.3047 20.1847C15.3047 19.8005 15.6161 19.489 16.0003 19.489C16.3845 19.489 16.696 19.8005 16.696 20.1847C16.696 20.5688 16.3845 20.8803 16.0003 20.8803Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGibraltar);
export default __webpack_public_path__ + "static/media/flag_gibraltar.8cfbc8711dc03fdb1d03ac0dbc3f49e5.svg";
export { ForwardRef as ReactComponent };